'use client'

import { motion } from 'framer-motion'

interface UpdatesDateSidebarProps {
    dates: string[]
    selectedDate: string
    onDateSelect: (date: string) => void
}

export function UpdatesDateSidebar({ dates, selectedDate, onDateSelect }: UpdatesDateSidebarProps) {
    return (
        <div className="sticky top-30 h-fit">
            <div
                className="relative  max-h-[200px] overflow-y-auto scrollbar-hide"
                style={{
                    maskImage:
                        'radial-gradient(ellipse 100% 60% at 50% 50%, black 40%, transparent 100%)',
                    WebkitMaskImage:
                        'radial-gradient(ellipse 100% 60% at 50% 50%, black 40%, transparent 100%)',
                }}
            >
                <div className="flex flex-col space-y-2 py-8">
                    {dates.map((date) => {
                        const isSelected = date === selectedDate
                        return (
                            <motion.button
                                key={date}
                                onClick={() => onDateSelect(date)}
                                className={`text-left px-4 py-2 rounded-lg transition-colors relative ${
                                    isSelected
                                        ? 'text-black-80'
                                        : 'text-black-40 hover:text-black-60'
                                }`}
                                whileHover={{ x: 4 }}
                                transition={{ duration: 0.2 }}
                            >
                                {isSelected && (
                                    <motion.div
                                        layoutId="activeDate"
                                        className="absolute inset-0 bg-black-6 rounded-lg"
                                        transition={{
                                            type: 'spring',
                                            stiffness: 500,
                                            damping: 30,
                                        }}
                                    />
                                )}
                                <span className="relative z-10 text-sm font-medium">{date}</span>
                            </motion.button>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}
